import api from "@/lib/api";

const ESCPOS_CLASS = 7;

async function fetchEscpos(playId, token) {
  const res = await fetch(api.escposUrl(playId, token));
  if (!res.ok) throw new Error("Ricevuta non disponibile");
  return new Uint8Array(await res.arrayBuffer());
}

function findOutEndpoint(device) {
  for (const cfg of device.configurations) {
    for (const iface of cfg.interfaces) {
      for (const alt of iface.alternates) {
        if (alt.interfaceClass !== ESCPOS_CLASS && alt.interfaceClass !== 0xff) continue;
        const ep = alt.endpoints.find((e) => e.direction === "out");
        if (ep) return { iface: iface.interfaceNumber, ep: ep.endpointNumber, cfg: cfg.configurationValue };
      }
    }
  }
  return null;
}

export const usbSupported = () => typeof navigator !== "undefined" && !!navigator.usb;

export async function pairUsbPrinter() {
  return navigator.usb.requestDevice({ filters: [{ classCode: ESCPOS_CLASS }] });
}

export async function printUsb(playId, { requestIfNeeded = false, token } = {}) {
  if (!usbSupported()) throw new Error("WebUSB non supportato da questo browser");
  let [device] = await navigator.usb.getDevices();
  if (!device) {
    if (!requestIfNeeded) throw new Error("Nessuna stampante USB autorizzata");
    device = await pairUsbPrinter();
  }
  const data = await fetchEscpos(playId, token);
  await device.open();
  const target = findOutEndpoint(device);
  if (!target) throw new Error("Stampante USB non compatibile");
  if (device.configuration?.configurationValue !== target.cfg) await device.selectConfiguration(target.cfg);
  await device.claimInterface(target.iface);
  try {
    const CHUNK = 4096;
    for (let i = 0; i < data.length; i += CHUNK) {
      await device.transferOut(target.ep, data.slice(i, i + CHUNK));
    }
  } finally {
    await device.releaseInterface(target.iface).catch(() => {});
    await device.close().catch(() => {});
  }
}
